import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './scripts/redux/store/configureStore'
import './styles/metroStyle.css';
import './styles/global.less';
import './styles/index.less';
import App from './scripts/App';
import * as serviceWorker from './scripts/util/serviceWorker';
import { ConfigProvider } from "antd"
import zhCN from 'antd/lib/locale-provider/zh_CN';


/*eslint no-extend-native: ["error", { "exceptions": ["Number"] }]*/
Number.prototype.toFixed = function(length)
{
    let carry = 0; //存放进位标志
    let num,multiple; //num为原浮点数放大multiple倍后的数，multiple为10的length次方
    const str = this + ''; //将调用该方法的数字转为字符串
    let dot = str.indexOf("."); //找到小数点的位置
    const lastdotNumber =  Number(str.substr(dot+length-1,1))
    const dotNumber =  Number(str.substr(dot+length+1,1))
    if(str.substr(dot+length+1,1)>5) { //找到要进行舍入的数的位置，手动判断是否大于5，满足条件进位标志置为1
        carry=1;
    } else if ((dotNumber === 5) && (lastdotNumber%2 === 1)) { // 判断是否等于5,并找到要进行舍入的数的前一个数位置，手动判断是否为奇数，满足条件进位标志置为1
        carry=1;
    }
    multiple = Math.pow(10,length); //设置浮点数要扩大的倍数
    num = Math.floor(this * multiple) + carry; //去掉舍入位后的所有数，然后加上我们的手动进位数
    let result = num/multiple + ''; //将进位后的整数再缩小为原浮点数
    /*
    * 处理进位后无小数
    */
    dot = result.indexOf(".");
    if(dot < 0){
        result += '.';
        dot = result.indexOf(".");
    }
    /*
    * 处理多次进位
    */
    const len = result.length - (dot+1);
    if(len < length){
        for(let i = 0; i < length - len; i++){
            result += 0;
        }
    }
    return result;
}

window.Number.prototype.toFixed=function (d) {
    let s=this+"";
    if(!d)d=0;
    if(s.indexOf(".")===-1)s+=".";
    s+=new Array(d+1).join("0");
    if(new RegExp("^(-|\\+)?(\\d+(\\.\\d{0,"+(d+1)+"})?)\\d*$").test(s)){
        s="0"+RegExp.$2
        let pm=RegExp.$1,a=RegExp.$3.length,b=true;
        if(a===d+2){
            a=s.match(/\d/g);
            if(parseInt(a[a.length-1])>4){
                for(var i=a.length-2;i>=0;i--){
                    a[i]=parseInt(a[i])+1;
                    if(a[i]===10){
                        a[i]=0;
                        b=i!==1;
                    }else break;
                }
            }
            s=a.join("").replace(new RegExp("(\\d+)(\\d{"+d+"})\\d$"),"$1.$2");

        }if(b)s=s.substr(1);
        return (pm+s).replace(/\.$/,"");
    }return this+"";

};

if(!window.Array.prototype.remove){
    window.Array.prototype.remove = function(index){
        this.splice(index, 1);
    }
}
if(!window.Array.prototype.removeNULL){
    window.Array.prototype.removeNULL = function(){
        for(var index = 0; index < this.length ; index++){
            if(this[index] === "" || this[index] == null){
                this.splice(index, 1);
                this.removeNULL();
            }
        }
    }
}

const store = configureStore()
window.$store = store;
ReactDOM.render(
    <Provider store={store}>
        <ConfigProvider locale={zhCN}>
            <App />
        </ConfigProvider>
    </Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
